import { registerPlugin } from '@capacitor/core';

export interface AppActionsPlugin {
    echo(options: { value: string }): Promise<{ value: string }>;
}
const AppActions = registerPlugin<AppActionsPlugin>('AppActions');

export default AppActions;